import logoGold from "../assets/akalibe-logo.png";
import logoCream from "../assets/akalibe-logo-cream.png";

export const LOGO = logoGold;
export const LOGO_CREAM = logoCream;

export const ARTIST = {
  name: "AKALIBE",
  tagline: "Pop d'auteur. C'est mon tour d'émerger.",
  // First person, real bio (source: official biography, Lyon)
  bio:
    "Je suis Akalibe, artiste basée à Lyon. J'écris et je chante une indie-pop teintée de R&B et d'influences expérimentales, en anglais comme en français. Ma voix se façonne selon l'émotion : de l'acoustique dépouillé à la fusion la plus vibrante. Ma musique ressemble à un souvenir : nostalgique, rêveuse, profondément humaine.",
  instagram: "https://www.instagram.com/akalibe_official",
  tiktok: "https://www.tiktok.com/@akalibe_official",
  youtube: "https://www.youtube.com/@akalibe0571",
  email: "contact@akalibe.com",
};

export const QUOTE = "Ma musique ressemble à un souvenir : nostalgique, rêveuse, profondément humaine.";

// Real career highlights (source: official biography)
export const HIGHLIGHTS = [
  { year: "2022", text: "America's Got Talent : mon audition m'a ouverte à une attention internationale." },
  { year: "2022", text: "Sur scène à Villeurbanne, Capitale française de la Culture." },
  { year: "Lyon", text: "Gala à l'Hôtel de Ville pour le programme d'entrepreneuriat de l'association SINGA." },
  { year: "Collectif", text: "Membre de Studio Hirundo : collaborations & initiatives communautaires." },
];

// Verified release info
export const RELEASE = {
  title: "My Turn",
  kind: "Premier single · disponible partout",
  length: "03:13",
  streams: "6 286",
  smartLink: "https://stem.ffm.to/myturn",
  youtubeId: "RDyEqIw37KY",
  youtubeUrl: "https://www.youtube.com/watch?v=RDyEqIw37KY",
  appleMusic: "https://music.apple.com/au/song/my-turn/1842182382",
  intro:
    "« My Turn », c'est mon premier single, mon histoire, celle de passer de l'ombre à la lumière. Gagnante de la BeatStars Draft Class (saison 1), repérée parmi plus de 4 000 candidatures par Kato On The Track et produite par VOV Productions, j'ai transformé ma vulnérabilité en un hymne indie-pop.",
  forFans: ["Clairo", "Olivia Dean", "Girl in Red"],
};

export const TEASER = {
  kind: "Nouveau · Teaser",
  title: "One More Gaze",
  youtubeId: "VO5VD7LovrM",
  youtubeUrl: "https://youtu.be/VO5VD7LovrM",
  intro:
    "Mon prochain morceau se dévoile. « One More Gaze » : un dernier regard, une nouvelle histoire. Voici le teaser, rien que pour vous.",
};

export const PROJECT = {
  status: "Projet en cours",
  title: "Un nouveau projet arrive.",
  text:
    "Je suis en studio. De nouveaux morceaux, une nouvelle direction visuelle, et bientôt une sortie que je prépare pour vous. Rejoignez le cercle pour être les premiers au courant.",
};

export const IMAGES = {
  heroPortrait:
    "https://www.akalibe.com/wp-content/uploads/go-x/u/eb0a4034-fdb9-4d80-854e-bdee9a4bf7d9/l0,t85,w682,h682/image.jpg",
  heroBg:
    "https://images.pexels.com/photos/21031387/pexels-photo-21031387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  bwPortrait:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_artist-universe-pro/artifacts/3vt7lmfm_Akalibe%201.jpeg",
  colorPortrait:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_artist-universe-pro/artifacts/j6db0x9y_B%203.webp",
  livePhoto:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_artist-universe-pro/artifacts/ov9ys1b8_Photo%20Bliss%20-%20Labo%20Transbo%2005-03-2022.jpg",
  manifesto:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_artist-universe-pro/artifacts/j6db0x9y_B%203.webp",
  videoCover:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_artist-universe-pro/artifacts/w5qbspu8_Video%20Cover.png",
  studio:
    "https://www.akalibe.com/wp-content/uploads/go-x/u/3b5996b0-e3f2-4c92-971c-96cb854beece/l0,t0,w1023,h796/image.jpg",
};

// Real stats (Spotify screenshot + biography)
export const STATS = [
  { value: "33", label: "Auditeurs mensuels · Spotify" },
  { value: "6 286", label: "Écoutes de « My Turn »" },
  { value: "2022", label: "America's Got Talent" },
];

export const LISTEN = [
  { id: "spotify", name: "Spotify", handle: "33 auditeurs mensuels · 6 286 écoutes", cta: "Écouter", url: "https://stem.ffm.to/myturn" },
  { id: "applemusic", name: "Apple Music", cta: "Écouter", url: "https://music.apple.com/au/song/my-turn/1842182382" },
  { id: "youtube", name: "YouTube", cta: "Regarder", url: "https://www.youtube.com/watch?v=RDyEqIw37KY" },
  { id: "deezer", name: "Deezer", cta: "Écouter", url: "https://stem.ffm.to/myturn" },
  { id: "soundcloud", name: "SoundCloud", cta: "Écouter", url: "https://stem.ffm.to/myturn" },
];

export const FOLLOW = [
  { id: "instagram", name: "Instagram", handle: "@akalibe_official", url: "https://www.instagram.com/akalibe_official" },
  { id: "tiktok", name: "TikTok", handle: "@akalibe_official", url: "https://www.tiktok.com/@akalibe_official" },
  { id: "youtube", name: "YouTube", handle: "@akalibe0571", url: "https://www.youtube.com/@akalibe0571" },
];

export const MARQUEE_WORDS = [
  "MY TURN", "INDIE POP", "R&B", "LYON", "POP D'AUTEUR", "AKALIBE",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Je fusionne les arts",
    body: "J'écris et je chante en indie-pop et R&B, avec des touches expérimentales. Ma voix se façonne selon l'émotion, de l'acoustique dépouillé à la fusion vibrante : un seul univers sensoriel.",
  },
  {
    n: "02",
    title: "J'écris ce que je vis",
    body: "Mes morceaux sont originaux, en anglais et en français, empreints d'une poétique intime et nostalgique. Chaque texte est une confidence que je vous livre.",
  },
  {
    n: "03",
    title: "Je crée du lien",
    body: "À Lyon, je m'engage dans des initiatives communautaires et le collectif Studio Hirundo. Ici, on se parle en direct : vous ne suivez pas juste une artiste, vous faites partie de l'histoire.",
  },
  {
    n: "04",
    title: "C'est mon tour",
    body: "De l'ombre à la lumière : My Turn n'est que le début. Un nouveau projet est déjà en route, et je compte bien le porter au monde avec vous.",
  },
];

export const ABOUT = {
  title: "Akalibe : le voyage d'une étoile",
  paragraphs: [
    "Artiste prometteuse, je suis reconnue pour mon talent inné et ma passion pour la musique. Originaire de la région lyonnaise, j'ai commencé très jeune, en m'inspirant d'influences culturelles et musicales variées.",
    "Ma voix captivante et mes textes réfléchis traduisent ma sensibilité artistique. Entre performances live et collaborations avec d'autres artistes, je ne cesse d'évoluer et de toucher le cœur de mon public.",
    "Fusionner les genres, c'est mon terrain de jeu : je cherche constamment à innover, en restant fidèle à qui je suis. Un talent né, animé par l'authenticité et un engagement sincère envers la musique.",
  ],
};

export const NAV_LINKS = [
  { label: "Teaser", href: "#top" },
  { label: "À propos", href: "#about" },
  { label: "Galerie", href: "#galerie" },
  { label: "Le Salon", href: "#chat" },
  { label: "Contact", href: "#contact" },
];
